<div *ngIf="city?.header" class="content-grid mdl-grid city-banner" [defaultImage]="city?.headerMicro" [lazyLoad]="city?.header">
</div>
<div class="city" *ngIf="city">
    <div class="city-general">
        <div class="city-general__name">
            <i class="material-icons">location_on</i>
            <div class="title">
                <span class="title-name">{{city?.location === 'Las Palmas de Gran Canaria' ?  'Gran Canaria' : city?.location}}</span>
                <span class="title-country">{{city?.country}}</span>
            </div>
        </div>
        <div class="mdl-cell--hide-phone city-general__tours">
            <div class="links" (click)="scrollIntoView('prods_princ')">
                <li><a fragment="tours">{{'TOURS' | translate}}</a></li>
            </div>
            <div class="links" (click)="scrollIntoView('about_target')">
                <li><a fragment="about">{{'ABOUT' | translate}} {{city?.location === 'Las Palmas de Gran Canaria' ?  'de Gran Canaria' : city?.location}}</a></li>
            </div>
        </div>
    </div>
    <div class="content-grid mdl-grid content-height product-view__min">
        <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone mdl-cell--12-col-tablet filter">
            <mat-expansion-panel class="filter--panel" [expanded]="isDesktop">
                <mat-expansion-panel-header class="filter--panel__header  mdl-cell--hide-desktop">
                  <mat-panel-title>
                    <mat-icon matPrefix>filter_list</mat-icon>  
                    <span class="filter--panel__header-text">Apply filters</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
              
                <filter-bar [categories]="lstCategories" (selectedcategories)="onSelectedCatgoriesChange($event)" (textFilter)="onFilterTextChange($event)"></filter-bar>
              
            </mat-expansion-panel>
       
        </div>
        <div class="mdl-cell mdl-cell--9-col mdl-cell--12-col-phone mdl-cell--9-col-tablet">
            <product-viewer [bg-color]="'#FAFAFA'" id="prods_princ" title="{{'TOP_PRODUCTS' | translate}}" [items]="filteredProducts" *ngIf="filteredProducts?.length > 0"
                [pageable]="hasNext" (onLoadMore)="loadMore()"></product-viewer>
        </div>
    </div>
    <div *ngIf="city?.aboutImage" id="about_target" class="content-grid mdl-grid banner-about__B" [defaultImage]="city?.aboutMicroImage" [lazyLoad]="city.aboutImage">
        <div class="mdl-cell mdl-cell--12-col content-centered city-title">
            <h2 class="h2">{{'ABOUT_TITLE' | translate}} {{city?.location === 'Las Palmas de Gran Canaria' ?  'Gran Canaria' : city?.location}}</h2>
            <h5 class="h5">
                {{'ABOUT_SUBTITLE' | translate}}
            </h5>
        </div>
    </div>
    <about-city *ngFor="let about of abouts; let i = index" [item]="about" [position]="i%2 == 1 ? 'right':'left'" [index]="i"></about-city>
    <div *ngIf="city?.poiImage != null" id="map" class="content-grid mdl-grid">
        <div class="mdl-layout-spacer"></div>
        <div class="mdl-cell mdl-cell--8-col mdl-cell--12-col-phone mdl-cell--12-col-tablet content-centered">
            <h2 id="poi_target">{{'POINTS_INTEREST' | translate}}</h2>
        </div>
        <div class="mdl-layout-spacer"></div>
    </div>
    <img *ngIf="city?.poiImage != null" src="{{city?.poiImage}}" width="100%" alt="point of interest - {{city?.location}}"/>
</div>
<div class="internal-links content-grid mdl-grid content-grey">
    <div class="mdl-layout-spacer"></div>
    <div class="mdl-cell mdl-cell--10-col mdl-cell--12-col-phone mdl-cell--12-col-tablet">
        <!-- <internal-links class="new-internal" *ngIf="topLocations" title="{{'POPULAR_DESTINATIONS' | translate}}" [items]="topLocations"></internal-links> -->
        <internal-links *ngIf="topProductsAnyLocation" title="{{'POPULAR_PRODUCTS' | translate}}" [items]="topProductsAnyLocation"></internal-links>
    </div>
    <div class="mdl-layout-spacer"></div>
</div>